import React from "react";

export default function Title() {
  return (
    <>
      <h2>PCB Instant Quote</h2>
      <p className="sub-title">
        Configure your PCB online, calculate the estimated price instantly, and
        save the quote for checkout or manual follow-up.{" "}
        <em>Fields marked with * are mandatory.</em>
      </p>
    </>
  );
}
